import { ApiResponse, HouseFormData, UploadResponse } from "../components/types";


const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export class ApiService {
  private static async makeRequest<T>(
    endpoint: string,
    options: RequestInit = {}
  ): Promise<ApiResponse<T>> {
    try {
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        headers: {
          'Content-Type': 'application/json',
          ...options.headers,
        },
        ...options,
      });

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('API Error:', error);
      return {
        success: false,
        message: 'Error de comunicación con el servidor',
        error: error instanceof Error ? error.message : 'Error desconocido',
      };
    }
  }

  static async submitHouseForm(formData: HouseFormData): Promise<UploadResponse> {
    const data = new FormData();
    
    // Agregar datos del formulario
    data.append('nombre', formData.nombre);
    data.append('email', formData.email);
    data.append('telefono', formData.telefono);
    data.append('direccion', formData.direccion);
    data.append('tipo', formData.tipo);
    if (formData.metros) data.append('metros', formData.metros.toString());
    if (formData.habitaciones) data.append('habitaciones', formData.habitaciones);
    if (formData.banos) data.append('banos', formData.banos);
    data.append('precio', formData.precio);
    if (formData.estado) data.append('estado', formData.estado);
    data.append('descripcion', formData.descripcion);
    if (formData.razon) data.append('razon', formData.razon);

    // // Agregar fotos
    // if (formData.fotos) {
    //   for (let i = 0; i < formData.fotos.length; i++) {
    //     data.append('fotos[]', formData.fotos[i]);
    //   }
    // }

    try {
      const response = await fetch(`${API_BASE_URL}/upload-api.php`, {
        method: 'POST',
        body: data,
      });

      return await response.json();
    } catch (error) {
      console.error('Upload Error:', error);
      return {
        success: false,
        message: 'Error al enviar el formulario',
      };
    }
  }

  static async getLeads(): Promise<ApiResponse<any[]>> {
    return this.makeRequest('/get-leads.php');
  }
}

// Utilidades de validación
export class ValidationUtils {
  static validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  static validatePhone(phone: string): boolean {
    const phoneRegex = /^[+]?[\d\s\-()]{9,}$/;
    return phoneRegex.test(phone);
  }

  static validateFormData(formData: HouseFormData): string[] {
    const errors: string[] = [];

    if (!formData.nombre.trim()) {
      errors.push('El nombre es obligatorio');
    }

    if (!formData.email.trim()) {
      errors.push('El email es obligatorio');
    } else if (!this.validateEmail(formData.email)) {
      errors.push('El email no es válido');
    }

    if (!formData.telefono.trim()) {
      errors.push('El teléfono es obligatorio');
    } else if (!this.validatePhone(formData.telefono)) {
      errors.push('El teléfono no es válido');
    }

    if (!formData.direccion.trim()) {
      errors.push('La dirección es obligatoria');
    }

    if (!formData.precio.trim()) {
      errors.push('El precio es obligatorio');
    }

    if (!formData.descripcion.trim()) {
      errors.push('La descripción es obligatoria');
    }

    // if (!formData.fotos || formData.fotos.length === 0) {
    //   errors.push('Debe subir al menos una foto');
    // } else if (formData.fotos.length > 10) {
    //   errors.push('Máximo 10 fotos permitidas');
    // }

    return errors;
  }
}

// Utilidades de formato
export class FormatUtils {
  static formatPrice(price: string): string {
    // Remover caracteres no numéricos excepto puntos y comas
    const cleanPrice = price.replace(/[^\d.,]/g, '');
    return cleanPrice;
  }

  static formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  static formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
}